<canvas ref="assetConditionsChart"></canvas>

<script>
import { ColorUtil } from '@/utils/colorUtil';
import { Pie } from "vue-chartjs";
import _ from "lodash";

export default {
    name: "AssetConditionsChart",
    extends: Pie,
    props: {
        data: {
            type: Array,
            required: true,
        },
        labels: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            currentData: [],
            currentLabels: [],
        };
    },

    watch: {
        data(newVal) {
            if (!_.isEqual(newVal, this.currentData)) {
                this.currentData = [...newVal];
                this.renderPieChart();
            }
        },
        labels(newVal) {
            if (!_.isEqual(newVal, this.currentLabels)) {
                this.currentLabels = [...newVal];
                this.renderPieChart();
            }
        },
    },

    mounted() {
        ColorUtil.ensureColors(this.labels);

        this.currentData = [...this.data];
        this.currentLabels = [...this.labels];
        this.renderPieChart();
    },

    methods: {
        renderPieChart() {
            const colors = ColorUtil.getColors(this.labels);

            const chartData = {
                labels: this.currentLabels,
                datasets: [{
                    data: this.currentData,
                    borderWidth: 1,
                    backgroundColor: colors,
                }],
                hoverOffset: 4
            };

            const chartOptions = {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
            };

            this.renderChart(chartData, chartOptions);
        }
    }
};
</script>

<style scoped>
canvas {
    height: 250px !important;
}
</style>
